"use client";

import { useEffect, useState } from "react";
import { getPublicSetting } from "@/app/lib/api/public";

interface SiteMetadata {
  title: string;
  description: string;
}

export function SiteMetadata() {
  const [metadata, setMetadata] = useState<SiteMetadata>({
    title: "Flas Album",
    description: "Flas - Albüm ve Fotoğraf Hizmetleri",
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const [titleSetting, descSetting] = await Promise.all([
          getPublicSetting(2),
          getPublicSetting(3),
        ]);

        setMetadata({
          title: titleSetting?.value || metadata.title,
          description: descSetting?.value || metadata.description,
        });
      } catch (error) {
        console.error("Error fetching site metadata:", error);
      } finally {
        setLoaded(true);
      }
    };

    fetchMetadata();
  }, []);

  // This component doesn't render anything visible
  // It just updates the document title and meta description
  useEffect(() => {
    if (loaded && metadata.title) {
      document.title = metadata.title;
      
      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', metadata.description);
    }
  }, [loaded, metadata]);

  return null;
} 